import styled from "styled-components";

interface FlagContainerProps {
  direction: "ltr" | "rtl";
}

const FlagContainer = styled.div<FlagContainerProps>`
  width: 53px;
  height: 36px;
  transform: translateX(-9px);

  bottom: ${({ theme }) => theme.bottomFlag};
  left: ${({ theme, direction }) =>
    direction === "ltr" ? theme.leftFlag : "initial"};
  right: ${({ theme, direction }) =>
    direction === "rtl" ? theme.leftFlag : "initial"};
`;

export default FlagContainer;
